import React from 'react';
import get from 'lodash/get';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useInstitutionList } from './useInstitutionList';

interface Props {
  isInsurance?: boolean;
}

export const InstitutionNameInput = ({ isInsurance }: Props) => {
  const fieldPrefix = isInsurance ? '' : 'bankAccount.';

  const formBag = useFormContext();

  const { loadInstitutions, isLoading } = useInstitutionList();

  const [isOrion, isLinked] = formBag.watch(['bankAccount.IsOrion', 'bankAccount.IsLinked']);

  if (isLinked) {
    return null;
  }

  return (
    <Controller
      control={formBag.control}
      name={`${fieldPrefix}InstitutionName`}
      render={({ field: { value, onChange, ref } }) => (
        <Select
          isCreatable
          isAsync
          isPortal
          cacheOptions
          isLoading={isLoading}
          innerRef={ref}
          value={{ value, label: value }}
          loadOptions={loadInstitutions}
          onChange={opt => {
            if (opt) {
              const isNew = get(opt, '__isNew__', false) as boolean;

              if (!isNew) {
                formBag.setValue(`${fieldPrefix}InstitutionId`, opt.value);
                onChange(opt.label);
              } else {
                onChange('Unlisted Institution');
              }
            }
          }}
          aria-label="Financial Institution"
          label="Financial Institution"
          placeholder="Financial Institution"
          noOptionsMessage={() => 'Please enter your financial institution name'}
          formatCreateLabel={() => `Add Unlisted Institution`}
          disabled={isOrion}
        />
      )}
    />
  );
};
